import styles from '../BillingNew.module.scss'

const BillingSupportInfo = () => {
  return (
    <p className={styles.revisionLink}>
      For any billing concerns, we're here to help. Feel free to reach out via email at{' '}
      <a href="mailto:billing@directful.com" target="_blank" rel="noreferrer">
        billing@directful.com
      </a>{' '}
      or give us a call at <a href="tel:+16504497321">+1 (650) 449-7321</a>. If you need
      our W9 form, you can find it for download at{' '}
      <a href="https://directful.com/w9" target="_blank" rel="noreferrer">
        directful.com/w9
      </a>
      .
    </p>
  )
}

export default BillingSupportInfo
